'use es6';

import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIList from 'UIComponents/list/UIList';
import UILink from 'UIComponents/link/UILink';
import { getHowToCreateAnchorUrl } from '../../utils/anchor';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function HowToUseAnchorsTooltip({
  i18nKey,
  tooltipClassName
}) {
  return /*#__PURE__*/_jsx(UITooltip, {
    className: tooltipClassName,
    use: "longform",
    placement: "top",
    title: /*#__PURE__*/_jsxs(UIList, {
      styled: true,
      childClassName: "m-bottom-1",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('tooltipInfo1')
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('tooltipInfo2')
      }), /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('tooltipInfo3')
        }), ' ', /*#__PURE__*/_jsx(UILink, {
          href: getHowToCreateAnchorUrl(),
          external: true,
          children: I18n.text(i18nKey('learnMore'))
        })]
      })]
    }),
    children: /*#__PURE__*/_jsx(UILink, {
      children: I18n.text(i18nKey('tooltipLinkText'))
    })
  });
}
export function AnchorInputField({
  i18nKey,
  anchorId,
  invalidAnchorId,
  onChange
}) {
  let validationMessage = '';
  if (invalidAnchorId) {
    validationMessage = I18n.text(i18nKey(invalidAnchorId === 'duplicate' ? 'duplicateIdErrorMessage' : 'invalidIdErrorMessage'));
  }
  return /*#__PURE__*/_jsx(UIFormControl, {
    label: I18n.text(i18nKey('nameLabel')),
    className: "m-bottom-4",
    error: !!invalidAnchorId,
    validationMessage: validationMessage,
    children: /*#__PURE__*/_jsx(UITextInput, {
      autoFocus: true,
      "data-test-id": "anchor-name-input",
      value: anchorId,
      onChange: onChange,
      placeholder: I18n.text(i18nKey('placeholder')),
      maxLength: 50 // Prevent aggressively long anchor ids
    })
  });
}